namespace Solovis.Reports.LocalCache {
   

    export class ModelEnvironmentCachedDataClient implements Solovis.Portal.IModelEnvironmentCachedData {

        private _portalServices: Solovis.Portal.IPortalServices;

        private _modelEnv: InvData.ModelEnvironment;

        private _propDefsLoaded: boolean = false;
        private _pendingPropDefsPromise: Promise<any>;

        private _tagSetsLoaded: boolean = false;
        private _pendingTagSetsPromise: Promise<any>;

        private _exposureProfilesLoaded: boolean = false;
        private _pendingExposureProfilesPromise: Promise<any>;

        constructor(options?: {
            portalServices?: Solovis.Portal.IPortalServices
        }) {
            if (options && options.portalServices) {
                this._portalServices = options.portalServices;
            }
            else {
                this._portalServices = new Solovis.Portal.SitePortalServices();
            }
        }

        private _getOrCreateModelEnv() {
            if (!this._modelEnv) {
                this._modelEnv = new InvData.ModelEnvironment();
            }

            return this._modelEnv;
        }


        public async getPropertyDefinitionsAsync(): Promise<InvData.Models.IdAndCodeObjectIndex<InvData.PropertyDefinition>> {

            if (this._propDefsLoaded) {
                return this._modelEnv.propertyDefinitions;
            }
            else {
                if (!this._pendingPropDefsPromise) {
                    this._pendingPropDefsPromise = await this._portalServices.reportDataLoader().loadDataSetAsync(
                        "/Solovis/Metadata/ModelEnvironment",
                        {
                            propertyDefinitionOptions: {
                                loadAll: true
                            }
                        });
                }

                let response = await this._pendingPropDefsPromise;

                let propDefModelEnv = response.result.dataSet.modelEnvironment;
                let modelEnv = this._getOrCreateModelEnv();
                modelEnv.mergeEnvironmentData(propDefModelEnv);

                this._propDefsLoaded = true;
                this._pendingPropDefsPromise = null;
                return this._modelEnv.propertyDefinitions;
            }
        }


        public async getExposureProfilesAsync(): Promise<InvData.Models.IdAndCodeObjectIndex<any>> {

            if (this._exposureProfilesLoaded) {
                return this._modelEnv.exposureProfiles;
            }
            else {
                if (!this._pendingExposureProfilesPromise) {
                    this._pendingExposureProfilesPromise = await this._portalServices.reportDataLoader().loadDataSetAsync(
                        "/Solovis/Metadata/ModelEnvironment",
                        {
                            exposureProfileOptions: {
                                loadAll: true
                            }
                        });
                }

                let response = await this._pendingExposureProfilesPromise;

                let expProfileModelEnv = response.result.dataSet.modelEnvironment;
                let modelEnv = this._getOrCreateModelEnv();
                modelEnv.mergeEnvironmentData(expProfileModelEnv);

                this._exposureProfilesLoaded = true;
                this._pendingExposureProfilesPromise = null;
                return this._modelEnv.exposureProfiles;
            }
        }


        public async tryGetTagSetByIdAsync(tagSetId: number): Promise<InvData.Models.TagSet> {
            if (this._tagSetsLoaded) {
                return this._modelEnv.tagSets.tryGetById(tagSetId);
            }
            else {
                if (!this._pendingTagSetsPromise) {
                    this._pendingTagSetsPromise = await this._portalServices.reportDataLoader().loadDataSetAsync(
                        "/Solovis/Metadata/ModelEnvironment",
                        {
                            tagSetOptions: {
                                loadAll: true
                            }
                        });
                }

                let response = await this._pendingTagSetsPromise;

                let tagSetModelEnv = response.result.dataSet.modelEnvironment;
                let modelEnv = this._getOrCreateModelEnv();
                modelEnv.mergeEnvironmentData(tagSetModelEnv);

                this._tagSetsLoaded = true;
                this._pendingTagSetsPromise = null;
                return this._modelEnv.tagSets.tryGetById(tagSetId);
            }
        }
    }


    export const ModelEnvironmentCachedData: ModelEnvironmentCachedDataClient = new ModelEnvironmentCachedDataClient();
    
}